var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVideo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#A066AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.667 18.1663L20.3262 15.9996L22.667 13.8338V18.1663ZM18.5003 19.3329C18.5003 19.7929 18.127 20.1663 17.667 20.1663H10.167C9.70699 20.1663 9.33366 19.7929 9.33366 19.3329V12.6663C9.33366 12.2071 9.70699 11.8329 10.167 11.8329H17.667C18.127 11.8329 18.5003 12.2071 18.5003 12.6663V19.3329ZM23.5103 11.9546C22.9887 11.7271 22.3837 11.8263 21.9678 12.2096L20.167 13.8763V12.6663C20.167 11.2879 19.0453 10.1663 17.667 10.1663H10.167C8.78866 10.1663 7.66699 11.2879 7.66699 12.6663V19.3329C7.66699 20.7121 8.78866 21.8329 10.167 21.8329H17.667C19.0453 21.8329 20.167 20.7121 20.167 19.3329V18.1238L21.9678 19.7896C22.2345 20.0371 22.5803 20.1663 22.9328 20.1663C23.1278 20.1663 23.3237 20.1271 23.5103 20.0454C24.0178 19.8238 24.3337 19.3496 24.3337 18.8088V13.1913C24.3337 12.6504 24.0178 12.1763 23.5103 11.9546Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVideo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/video.94b5c616.svg";
export { ForwardRef as ReactComponent };